var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClickupMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "66px",
    viewBox: "0 0 55 66",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "symbol-color")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "68.01%",
    x2: "100%",
    y2: "68.01%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8930FD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49CCF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "68.01%",
    x2: "100%",
    y2: "68.01%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF02F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HS-home-page-refresh-2020_test",
    transform: "translate(-1147.000000, -6424.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol-color",
    transform: "translate(1147.000000, 6424.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.169230769,50.7220645 L10.2426923,42.9553548 C15.5946154,49.9854194 21.2807692,53.2258065 27.61,53.2258065 C33.9053846,53.2258065 39.4307692,50.0237419 44.5415385,43.0490323 L54.7588462,50.6283871 C47.3846154,60.6859355 38.2207692,66 27.61,66 C17.0330769,66 7.78038462,60.72 0.169230769,50.7220645 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-2)",
    points: "27.5761538 16.964129 9.64615385 32.5145806 1.35807692 22.8402581 27.6142308 0.0681290323 53.6630769 22.8572903 45.3369231 32.4975484"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClickupMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clickup-mark.45feeecd.svg";
export { ForwardRef as ReactComponent };